<template>
  <div id="nav">
    <router-link to="/profile"> Profile </router-link>|
    <router-link to="/programming"> Programming </router-link>|
    <router-link to="/illust"> Illust </router-link>
  </div>
</template>
